<div class="">
  <div class="col-12 d-flex">
    <h2
      mat-dialog-title
      style="display: block !important"
      class="w-100 d-flex justify-content-between"
    >
      {{ data?.members_list }} List - {{ data?.item?.title }}
    </h2>
    <span matDialogClose mat-dialog-close style="float: right">
      <img
        src="assets/images/close-white.svg"
        alt="close"
        style="margin-top: 15px"
      />
    </span>
  </div>
</div>

<mat-dialog-content class="">
  <div class="container-fluid p-0">
    <div class="re-agent-box">
      <div class="row mt-3" *ngIf="data.members_list === 'Members'">
        <ng-container *ngFor="let role of roles">
          <div
            class="col-12 col-md-4 col-sm-6 mb-3"
            *ngIf="
              totalRolesAssign.includes(role?._id) &&
              totalRolesAssign?.length > 0
            "
          >
            <!-- 
            [role?.value]
            [role?.value] -->
            <label class="re-agent-label">
              {{ role?.label }}
            </label>

            <ul class="re-agent-ulist">
              <li *ngFor="let user of users">
                {{ getUserName(user, user?.roleData, role?._id) }}
              </li>
            </ul>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</mat-dialog-content>
<div class="re-agent-data-not-found" *ngIf="roles?.length == 0">
  <p>No Records Found</p>
</div>

<mat-dialog-actions align="center" style="padding-top: 14px !important">
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
